/**
 * Button Component
 * Reusable button component with variants
 */

import styles from './Button.module.css';

export class Button {
  constructor({ text, href, variant = 'default', onClick, type = 'button' }) {
    this.text = text;
    this.href = href;
    this.variant = variant;
    this.onClick = onClick;
    this.type = type;
  }

  render() {
    const element = this.href ? document.createElement('a') : document.createElement('button');
    
    element.textContent = this.text;
    element.className = `${styles.button} ${styles[this.variant]}`;
    
    if (this.href) {
      element.href = this.href;
      element.setAttribute('role', 'button');
    } else {
      element.type = this.type;
      if (this.onClick) {
        element.addEventListener('click', this.onClick);
      }
    }

    return element;
  }
}
